import { appConstants } from "../../constants/appconstants";
import { postApiCall } from "../../utils/ApiMethods";

const FetchNotificationsAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/user-notification/notifications`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_FETCH_NOTIFICATIONS_ACTION', data: data }, data);
        dispatch(resData);
    }
}
const UpdateSubscribeAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/user-notification/update-subscription`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_UPDATE_SUBSCRIBE_ACTION' }, data);
        dispatch(resData);
    }
}

const ReadNotificationAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/user-notification/read`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_READ_NOTIFICATION_ACTION' }, data);
        dispatch(resData);
    }
}

const ReadAllNotificationAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/user-notification/read-all`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_READ_ALL_NOTIFICATION_ACTION' }, data);
        dispatch(resData);
    }
}
export { UpdateSubscribeAction, FetchNotificationsAction, ReadNotificationAction, ReadAllNotificationAction }